import React from "react";

export const HTMLContent = ({ content }) => (
  <div dangerouslySetInnerHTML={{ __html: content }} />
);

const Content = ({ content }) => <div className="content">{content}</div>;

export default Content;
